module.exports = __webpack_public_path__ + "img/img19.b0c15cd4.svg";